import { render, staticRenderFns } from "./JSelectCangku.vue?vue&type=template&id=650e96d0&scoped=true"
import script from "./JSelectCangku.vue?vue&type=script&lang=js"
export * from "./JSelectCangku.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650e96d0",
  null
  
)

export default component.exports